export const InvestorConditionsTestIds = {
  // InvestorConditionsTable.js
  ADD_CONDITION_BUTTON: 'investor-conditions.add-condition-button',
  BULK_PASTE_BUTTON: 'investor-conditions.bulk-paste-button',

  // InvestorConditionDrawer.js
  DRAWER_SAVE_BUTTON: 'investor-condition-drawer.save-button',

  // BulkPasteModal.js
  BULK_PASTE_INPUT: 'investor-bulk-paste.conditions-input',
  BULK_PASTE_CANCEL_BUTTON: 'investor-bulk-paste.cancel-button',
  BULK_PASTE_ADD_BUTTON: 'investor-bulk-paste.add-button',
};
